import { APIPaths } from "@/apis/api-config";

import BaseApi from "../base-api";

export class CompanyApi extends BaseApi {
  async postCompanyVerifyNewCode(
    requestBody: APIPaths["/partner-app/company/verify-new-code"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/partner-app/company/verify-new-code"]["post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post("/partner-app/company/verify-new-code", requestBody)).data;
  }
  async patchCompanyById(
    parameters: APIPaths["/partner-app/company/{id}"]["patch"]["parameters"]["path"],
    requestBody: APIPaths["/partner-app/company/{id}"]["patch"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/partner-app/company/{id}"]["patch"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.patch(`/partner-app/company/${parameters.id}`, requestBody)).data;
  }
}
